module.exports = __webpack_public_path__ + "static/img/btn3_hover.157af2a5.png";